import type { FormResponseValue } from "@tellescope/types-models";

export const isSubmittableResponse = (response: FormResponseValue): boolean => response.answer.type !== "Redirect";
